// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 4ndTTXQshOzm
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  initializeCodeComponentStates,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import Select from "../../Select"; // plasmic-import: r6GO1MnFYJAb/component
import { Select as Select2 } from "@plasmicpkgs/antd/skinny/registerSelect";
import { Option } from "@plasmicpkgs/antd/skinny/registerOption";
import PermissionChip from "../../PermissionChip"; // plasmic-import: SruSaz4XhKEy/component
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAddRoleModal.module.css"; // plasmic-import: 4ndTTXQshOzm/css

createPlasmicElementProxy;

export const PlasmicAddRoleModal__VariantProps = new Array();

export const PlasmicAddRoleModal__ArgProps = new Array();

const $$ = {};

function PlasmicAddRoleModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "roleName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "permissionSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__lSzj6)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__vBfh0
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h5
                data-plasmic-name={"h5"}
                data-plasmic-override={overrides.h5}
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5
                )}
              >
                {"Enter Role Name"}
              </h5>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      {(() => {
        const child$Props = {
          className: classNames("__wab_instance", sty.roleName),
          onChange: async (...eventArgs) => {
            generateStateOnChangePropForCodeComponents(
              $state,
              "value",
              ["roleName", "value"],
              AntdInput_Helpers
            ).apply(null, eventArgs);
          },
          placeholder: "Enter here",
          value: generateStateValueProp($state, ["roleName", "value"])
        };
        initializeCodeComponentStates(
          $state,
          [
            {
              name: "value",
              plasmicStateName: "roleName.value"
            }
          ],

          [],
          AntdInput_Helpers ?? {},
          child$Props
        );
        return (
          <AntdInput
            data-plasmic-name={"roleName"}
            data-plasmic-override={overrides.roleName}
            {...child$Props}
          />
        );
      })()}
      <div className={classNames(projectcss.all, sty.freeBox__nvw7N)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__e63KR
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h6
                data-plasmic-name={"h6"}
                data-plasmic-override={overrides.h6}
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.h6
                )}
              >
                {"Select permissions for this role"}
              </h6>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"permissionSelectStack"}
        data-plasmic-override={overrides.permissionSelectStack}
        className={classNames(projectcss.all, sty.permissionSelectStack)}
      >
        <Select
          data-plasmic-name={"permissionSelect"}
          data-plasmic-override={overrides.permissionSelect}
          className={classNames("__wab_instance", sty.permissionSelect)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["permissionSelect", "value"])(
                eventArgs[0]
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          options={(() => {
            const __composite = [
              { value: null, label: null },
              { value: null, label: null },
              { label: null, value: null },
              { label: null, value: null }
            ];

            __composite["0"]["value"] = "add_debtors";
            __composite["0"]["label"] = "Add Debtors";
            __composite["1"]["value"] = "view_debtors";
            __composite["1"]["label"] = "View Debtors";
            __composite["2"]["label"] = "Edit Debtors";
            __composite["2"]["value"] = "edit_debtors";
            __composite["3"]["label"] = "Invite Users";
            __composite["3"]["value"] = "invite_users";
            return __composite;
          })()}
          value={generateStateValueProp($state, ["permissionSelect", "value"])}
        />

        <Select2
          data-plasmic-name={"permissionSelectionStack"}
          data-plasmic-override={overrides.permissionSelectionStack}
          allowClear={true}
          bordered={false}
          className={classNames("__wab_instance", sty.permissionSelectionStack)}
          listHeight={256}
          mode={"multiple"}
          onChange={async (...eventArgs) => {
            generateStateOnChangeProp($state, [
              "permissionSelectionStack",
              "value"
            ]).apply(null, eventArgs);
          }}
          onDropdownVisibleChange={async (...eventArgs) => {
            generateStateOnChangeProp($state, [
              "permissionSelectionStack",
              "open"
            ]).apply(null, eventArgs);
          }}
          open={generateStateValueProp($state, [
            "permissionSelectionStack",
            "open"
          ])}
          placeholder={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__opKzs
              )}
            >
              {"Select"}
            </div>
          }
          showArrow={true}
          showSearch={true}
          size={"large"}
          value={generateStateValueProp($state, [
            "permissionSelectionStack",
            "value"
          ])}
          virtual={true}
        >
          <Option
            className={classNames("__wab_instance", sty.antdOption__jjEpx)}
            key={"add_debtor"}
            title={"Add Debtor"}
            value={"Add Debtor"}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__za4St
              )}
            >
              {"Option"}
            </div>
          </Option>
          <Option
            className={classNames("__wab_instance", sty.antdOption___3PBau)}
            key={"edit_debtor"}
            title={"Edit Debtor"}
            value={"Edit Debtor"}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__aPpC1
              )}
            >
              {"Option"}
            </div>
          </Option>
        </Select2>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__dv5Fe)}>
        <div
          data-plasmic-name={"permissionChipsStack"}
          data-plasmic-override={overrides.permissionChipsStack}
          className={classNames(projectcss.all, sty.permissionChipsStack)}
        >
          <PermissionChip
            data-plasmic-name={"permissionChip"}
            data-plasmic-override={overrides.permissionChip}
            className={classNames("__wab_instance", sty.permissionChip)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___8S4T
              )}
            >
              {"create invoice"}
            </div>
          </PermissionChip>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__mqkRn)}>
        <Button
          data-plasmic-name={"addRoleBtn"}
          data-plasmic-override={overrides.addRoleBtn}
          className={classNames("__wab_instance", sty.addRoleBtn)}
        >
          {"Add Role"}
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "h5",
    "roleName",
    "h6",
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack",
    "permissionChipsStack",
    "permissionChip",
    "addRoleBtn"
  ],

  h5: ["h5"],
  roleName: ["roleName"],
  h6: ["h6"],
  permissionSelectStack: [
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack"
  ],

  permissionSelect: ["permissionSelect"],
  permissionSelectionStack: ["permissionSelectionStack"],
  permissionChipsStack: ["permissionChipsStack", "permissionChip"],
  permissionChip: ["permissionChip"],
  addRoleBtn: ["addRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAddRoleModal__ArgProps,
          internalVariantPropNames: PlasmicAddRoleModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAddRoleModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAddRoleModal";
  } else {
    func.displayName = `PlasmicAddRoleModal.${nodeName}`;
  }
  return func;
}

export const PlasmicAddRoleModal = Object.assign(
  // Top-level PlasmicAddRoleModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h5: makeNodeComponent("h5"),
    roleName: makeNodeComponent("roleName"),
    h6: makeNodeComponent("h6"),
    permissionSelectStack: makeNodeComponent("permissionSelectStack"),
    permissionSelect: makeNodeComponent("permissionSelect"),
    permissionSelectionStack: makeNodeComponent("permissionSelectionStack"),
    permissionChipsStack: makeNodeComponent("permissionChipsStack"),
    permissionChip: makeNodeComponent("permissionChip"),
    addRoleBtn: makeNodeComponent("addRoleBtn"),
    // Metadata about props expected for PlasmicAddRoleModal
    internalVariantProps: PlasmicAddRoleModal__VariantProps,
    internalArgProps: PlasmicAddRoleModal__ArgProps
  }
);

export default PlasmicAddRoleModal;
/* prettier-ignore-end */
